<template>
  <div class="news-detail-page">
    <!-- <div class="wp">
      <div class="g-top">
        <div class="cur">
          当前位置：
          <a href="/">首页</a> &gt;
          <a href="javascript:void(0)" @click="goBackToNewsList">新闻资讯</a> &gt;
          <a href="javascript:void(0)">{{ articleTypeText }}</a> &gt;
          <span>{{ article.title }}</span>
        </div>
      </div>
    </div> -->
    
    <div class="row-d1">
      <div class="wp">
        <div class="col-l">
          <div class="m-details">
            <h1>{{ article.title || article.newNameCn }}</h1>
            <div class="info">
              <span>发布时间：{{ article.createTime || article.newCreateTime }}</span>
              <span>来源：{{ article.source || article.newSource  }}</span>
              <span>浏览量：{{ article.views || article.newViews || '0' }}</span>
              <!-- <div class="share">
                <span class="dib">分享到：</span>
                <div class="bdsharebuttonbox">
          <el-popover placement="top-start" width="230" trigger="hover">
            <QRCode alt="" codeName="二维码"
              content="https://connect.qq.com/widget/shareqq/index.html?url=http%3A%2F%2Fwww.beijingxibao.com&title=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8&desc=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8"
               :width="'200'" :height="'200'"></QRCode>
        
            <a href="#" slot="reference" class="bds_sqq"  title="分享到QQ好友"></a>
          </el-popover>


      <el-popover placement="top-start" width="230" trigger="hover">
            <QRCode alt="" codeName="二维码"
              content="https://connect.qq.com/widget/shareqq/index.html?url=http%3A%2F%2Fwww.beijingxibao.com&title=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8&desc=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8"
               :width="'200'" :height="'200'"></QRCode>
     
                  <a href="#"  slot="reference"  class="bds_weixin" data-cmd="weixin" title="分享到微信"></a>
          </el-popover>

              
                  <a href="https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http://www.beijingxibao.com&title=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8" class="bds_qzone" id="share-qzone" title="分享到QQ空间"></a>
                  <a href="https://service.weibo.com/share/share.php?url=http://www.beijingxibao.com&title=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8" class="bds_tsina" id="share-sina" title="分享到新浪微博"></a>
                </div>
              </div> -->
            </div>
            <div class="txt" v-html="article.content || article.newContentCn">
            </div>
            <div class="arrow">
              <div class="item prev" :class="{disabled: !previousArticle}">
                <a v-if="previousArticle" href="javascript:void(0);" @click="goToPreviousArticle">
                  上一篇：
                  <span>{{ previousArticle.title || previousArticle.newNameCn }}</span>
                </a>
                <span v-else class="disabled-text">上一篇：<span>没有了！</span></span>
              </div>
              <div class="item next" :class="{disabled: !nextArticle}">
                <a v-if="nextArticle" href="javascript:void(0);" @click="goToNextArticle">
                  下一篇：
                  <span>{{ nextArticle.title || nextArticle.newNameCn }}</span>
                </a>
                <span v-else class="disabled-text">下一篇：<span>没有了！</span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-r">
          <div class="m-t2">
            <h3>推荐新闻</h3>
          </div>
          <ul class="m-list9">
            <li v-for="rec in recommendedArticles" :key="rec.id || rec.newId">
              <a href="javascript:void(0);" class="con" @click="goToRecommendedArticle(rec)">
                <span class="date">{{ rec.createTime || rec.newCreateTime }}</span>
                <h3 class="tit">{{ rec.title || rec.newNameCn }}</h3>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from './Qrcode.vue'
export default {
  name: 'NewsDetail',
   components: {
    QRCode
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    allNews: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    articleTypeText() {
      const typeMap = {
        'industry': '行业动态',
        'company': '公司新闻',
        'product': '最新产品'
      };
      
      // 优先使用type字段，如果没有则根据newType判断
      if (this.article.type) {
        return typeMap[this.article.type] || '公司新闻';
      } else if (typeof this.article.newType !== 'undefined') {
        // API返回的newType，1表示公司新闻，0表示产品新闻
        return this.article.newType === 1 ? '公司新闻' : '最新产品';
      }
      
      return '公司新闻';
    },
    // 计算推荐文章，基于当前文章的类型排除当前文章
    recommendedArticles() {
      if (!this.article || !this.allNews) return [];
      
      // 获取当前文章类型，对于API返回的数据，newType为1表示公司新闻，0表示产品新闻
      let currentType = this.article.type;
      if (typeof this.article.newType !== 'undefined') {
        currentType = this.article.newType === 1 ? 'company' : 'product';
      } else if (!currentType) {
        currentType = this.article.newType === 1 ? 'company' : 'product';
      }
      
      return this.allNews
        .filter(item => {
          // 判断文章类型是否相同
          let itemType = item.type;
          if (typeof item.newType !== 'undefined') {
            itemType = item.newType === 1 ? 'company' : 'product';
          } else if (!itemType) {
            itemType = item.newType === 1 ? 'company' : 'product';
          }
          
          // 获取文章ID
          const itemId = item.id || item.newId;
          const articleId = this.article.id || this.article.newId;
          
          return itemType === currentType && itemId !== articleId;
        })
        .slice(0, 2);
    },
    // 计算上一篇和下一篇文章
    previousArticle() {
      if (!this.article || !this.allNews) return null;
      
      // 获取当前文章类型
      let currentType = this.article.type;
      if (typeof this.article.newType !== 'undefined') {
        currentType = this.article.newType === 1 ? 'company' : 'product';
      } else if (!currentType) {
        currentType = this.article.newType === 1 ? 'company' : 'product';
      }
      
      // 获取当前文章ID
      const currentId = this.article.id || this.article.newId;
      
      // 找到所有同类型的文章
      const sameTypeArticles = this.allNews.filter(item => {
        let itemType = item.type;
        if (typeof item.newType !== 'undefined') {
          itemType = item.newType === 1 ? 'company' : 'product';
        } else if (!itemType) {
          itemType = item.newType === 1 ? 'company' : 'product';
        }
        return itemType === currentType;
      });
      
      // 找到当前文章在同类文章中的索引
      const currentIndex = sameTypeArticles.findIndex(item => {
        const itemId = item.id || item.newId;
        return itemId === currentId;
      });
      
      // 如果当前文章是同类文章中的第一篇，则没有上一篇
      if (currentIndex <= 0) return null;
      
      return sameTypeArticles[currentIndex - 1];
    },
    nextArticle() {
      if (!this.article || !this.allNews) return null;
      
      // 获取当前文章类型
      let currentType = this.article.type;
      if (typeof this.article.newType !== 'undefined') {
        currentType = this.article.newType === 1 ? 'company' : 'product';
      } else if (!currentType) {
        currentType = this.article.newType === 1 ? 'company' : 'product';
      }
      
      // 获取当前文章ID
      const currentId = this.article.id || this.article.newId;
      
      // 找到所有同类型的文章
      const sameTypeArticles = this.allNews.filter(item => {
        let itemType = item.type;
        if (typeof item.newType !== 'undefined') {
          itemType = item.newType === 1 ? 'company' : 'product';
        } else if (!itemType) {
          itemType = item.newType === 1 ? 'company' : 'product';
        }
        return itemType === currentType;
      });
      
      // 找到当前文章在同类文章中的索引
      const currentIndex = sameTypeArticles.findIndex(item => {
        const itemId = item.id || item.newId;
        return itemId === currentId;
      });
      
      // 如果当前文章是同类文章中的最后一篇，则没有下一篇
      if (currentIndex === -1 || currentIndex >= sameTypeArticles.length - 1) return null;
      
      return sameTypeArticles[currentIndex + 1];
    }
  },
  methods: {
    shareToWeChat() {
      alert('微信分享功能待实现，需要集成微信JSSDK');
    },
    goBackToNewsList() {
      // 触发关闭详情的事件
      this.$emit('close-detail');
    },
    goToPreviousArticle() {
      if (this.previousArticle) {
        this.$emit('view-article', this.previousArticle);
      }
    },
    goToNextArticle() {
      if (this.nextArticle) {
        this.$emit('view-article', this.nextArticle);
      }
    },
    goToRecommendedArticle(article) {
      this.$emit('view-article', article);
    }
  }
}
</script>

<style >

.item.disabled a {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  color: #ccc;
}

.disabled-text {
  opacity: 0.5;
  color: #ccc;
}
</style>